import { memo } from 'react';
import styled, { css } from 'styled-components';

import type { CommonCheckboxProps } from '@wecasa/common/src/types/components';
import colors from '@wecasa/common/src/utils/colors';

import Icon from '../icon/icon';
import type { InputProps } from '../input/input';
import { HiddenInput } from '../utils';

const Container = styled.div`
  cursor: pointer;
`;

const checkedStyle = css`
  background-color: ${colors.orange100};
  border: none;
`;

const Square = styled.div<{ $checked: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  box-sizing: border-box;
  background-color: ${colors.white100};
  border: 1px solid ${colors.neutral100};
  ${(props) => props.$checked && checkedStyle}
`;

export type CheckboxProps = CommonCheckboxProps & Pick<InputProps, 'onChange' | 'id' | 'name' | 'value' | 'className'>;

const Checkbox = ({ id, name, onChange, value, checked, className }: CheckboxProps) => (
  <Container className={className}>
    <HiddenInput checked={checked} id={id} name={name} onChange={onChange} type='checkbox' value={value} />
    <Square $checked={checked}>
      <Icon size={20} name='yes' color={colors.white100} />
    </Square>
  </Container>
);

export default memo(Checkbox);
